import api from "api";
import { useNavigate } from "react-router-dom";
import BlockHeader from "component/BlockHeader/BlockHeader";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import stateMap from "store/stateMap";
import store from "store/store";
import "./style.scss";
import { PageCredential } from "component/PageCredential";
import {SurveyForm, SurveyBuilder} from "component/EditSurvey";
import { MaterialSymbol } from "react-material-symbols";
import fancybox, { popinfo } from "component/Fancybox/Fancybox";
import Sidebar from "component/Sidebar";
import { ComponentSurvey, ComponentSurveyRunner } from "component/Survey";
import ThreeDots from "component/ThreeDots";

const DownloadResponse = (survey, authToken) => {
    const DownloadingResponse = popinfo('preloader', 'Download Response', 'Please Wait');

    api('/SurveyDownloadResponse', 'post', {
        survey_id : survey.SurveyID
    }, 'Bearer ' + authToken)
        .then(response => {
            DownloadingResponse.close();
            let element = document.createElement('a');
            element.setAttribute('href', response.data.download_url);
            element.setAttribute('download', response.data.filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        })
        .catch(error => {
            popinfo('error', 'Download Response', error, {}, DownloadingResponse);
        });
};

const PageInitiativeInsideSurvey = connect(stateMap)((props) => {
    const [activeSubPage, setActiveSubPage]         = useState('list');
    const [surveys, setSurveys]                     = useState([]);
    const [surveyLoading, setSurveyLoading]         = useState(true);
    const [surveyLoadTick, setSurveyLoadTick]       = useState(() => Date.now());
    let navigate                                    = useNavigate();

    useEffect(() => {
        if(!props.initiative.initiative)
        {
            return;
        }

        if(!props.auth.user)
        {
            return;
        }

        // api('/Initiative/SATPointCandidate', 'get', {
        //     initiative_id : props.initiative.initiative.InitiativeID
        // }, 'Bearer ' + props.auth.token)
        //     .then(response => {
        //         setMembers(response.member);

        //         setCheckedMember(update([], {
        //             $set : _.map(response.member,'UserID')
        //         }));
        //     })

    }, [props.initiative, props.auth.user]);

    const SaveSurvey = (Survey) => {
        return new Promise((resolve) => {

            const SavingSurvey = popinfo('preloader', 'Saving Your Survey', 'Please Wait');

            api('/Survey', 'post', Survey, 'Bearer ' + props.auth.token)
                .then(response => {
                    setSurveyLoadTick(Date.now());
                    SavingSurvey.close();
                    resolve();
                })
                .catch(response => {
                    popinfo('error', 'Error Saving Survey', response, {}, SavingSurvey);
                })
        })
    };

    const GoToSurvey = (survey) => {
        if(survey.SurveyEngineType === 'Internal')
        {
            if(survey.IsPublished === 1)
            {
                navigate(`../response-survey/${survey.SurveyID}`);
            }
            else
            {
                fancybox(<ComponentSurveyRunner surveyID={survey.SurveyID} onComplete={answers => {
                    console.log(answers);
                }} />)
            }
        }
        else
        {
            if(survey.IsPublished === 0)
            {
                window.open(survey.SurveyLink, '_blank');
            }
            else
            {
                
                const UpdatingTotalView = popinfo('preloader', 'Please Wait', 'Checking for survey url');
                api('/SurveyAddView', 'post', {survey_id : survey.SurveyID}, 'Bearer ' + props.auth.token)
                    .then(() => {
                        UpdatingTotalView.close();
                        window.open(survey.SurveyLink, '_blank');
                    })
                    .catch((err) => {
                        popinfo('error', 'We are sorry', err, {}, UpdatingTotalView);
                    })
            }
        }
    }

    

    useEffect(() => {



        if(props.initiative.access)
        {
            setSurveyLoading(true);
    
            api('/Survey', 'get', {
                attached_type : 'initiative'
                ,attached_to : props.initiative.initiative.InitiativeID
                ,posts_per_page : -1
                ,include_body : true
                ,sortby : 'Survey.IsPublished ASC, Survey.CreatedAt DESC'
                ,sort : ' '
                ,include_draft : (props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin') ? 1 : 0
            }, 'Bearer ' + props.auth.token)
                .then(response => {
                    setSurveyLoading(false);
                    setSurveys(response.survey);
                })
                .catch(err => {
    
                })
        }
        else
        {
            setSurveyLoading(false);
        }

    }, [props.initiative,props.auth, activeSubPage, surveyLoadTick])


    return (
        <div className="initiative-inside-survey container">
            <PageCredential title={`${props.initiative.initiative.Title} | Survey`} />
            <div className={`initiative-survey-container ${props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' && '--admin'}`}>
                {
                    props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' &&
                    <Sidebar>
                        <div className="filters-boxes">
                            <div className="filter-box">
                                <div className="wrapper">
                                    
                                    <div className="filter-body">
                                        <ul className="filter-items">
                                            <li className={`leading-text filter-item relative  ${activeSubPage === 'list' && 'active'}`}>
                                                List of Survey
                                                <button className="absolute inset" onClick={() => setActiveSubPage('list')}>
                                                </button>
                                            </li>
                                            <li className={`leading-text filter-item relative  ${activeSubPage === 'summary' && 'active'}`}>
                                                Survey Summary
                                                <button className="absolute inset" onClick={() => setActiveSubPage('summary')}>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Sidebar>
                }
                <div className="initiative-survey-container--inside">
                    {
                        activeSubPage === 'list' && (
                            <div>
                                {
                                    props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' &&
                                    <button className="btn" onClick={e => {
                                        const CreateSurvey = fancybox(
                                            <div className="generic-form">
                                                <BlockHeader title="Create a Survey" desc="Create and manage survey questions for this initiative"/>
                                                <SurveyForm 
                                                    onSave={(editedSurvey) => {
                                                        SaveSurvey({
                                                            ...editedSurvey
                                                            ,AttachedTo         : props.initiative.initiative.InitiativeID
                                                            ,AttachedType       : 'initiative'
                                                        })
                                                            .then(() => CreateSurvey.close())
                                                    }}
                                                    onCancel={() => CreateSurvey.close()}
                                                />
                                            </div>
                                        )
                                    }}>
                                        <MaterialSymbol icon="add_circle"/> Add New
                                    </button>
                                }
                                <ul className="list-of-surveys">
                                    {
                                        surveyLoading && [...Array(4)].map((_, i) => (
                                            <li key={i} className="list-of-survey">
                                                <div className="component-survey-item">
                                                    <span className="skeleton mb-sm"></span>
                                                    <span className="skeleton mb-sm"></span>
                                                    <span className="skeleton mb-lg"></span>
                                                    <span className="skeleton mb-lg" style={{height : '100px'}}></span>
                                                    <span className="skeleton mb-sm"></span>
                                                    <span className="skeleton"></span>
                                                </div>
                                            </li>
                                        ))
                                    }
                                    {
                                        !surveyLoading && surveys.length > 0 && surveys.map(survey =>(
                                            <li key={survey.SurveyID} className="list-of-survey">
                                                <ComponentSurvey survey={survey} onClickCTA={survey => {
                                                    GoToSurvey(survey);
                                                }} />
                                                {
                                                    props.initiative.access.membership && props.initiative.access.membership.MemberType === 'admin' && (
                                                        <ThreeDots>
                                                            <button onClick={ e => {
                                                                e.preventDefault();
                                                                const EditSurvey = fancybox(
                                                                    <div className="generic-form">
                                                                        <BlockHeader title="Create a Survey" desc="Create and manage survey questions for this initiative"/>
                                                                        <SurveyForm 
                                                                            initialSurveyData={survey}
                                                                            onSave={editedSurvey => {
                                                                                SaveSurvey({
                                                                                    ...editedSurvey
                                                                                    ,AttachedTo         : props.initiative.initiative.InitiativeID
                                                                                    ,AttachedType       : 'initiative'
                                                                                })
                                                                                    .then(() => EditSurvey.close())
                                                                            }}
                                                                            onCancel={() => EditSurvey.close()}
                                                                        />
                                                                    </div>
                                                                )

                                                            }}>Edit</button>
                                                            <button onClick={ e => {
                                                                e.preventDefault();

                                                                if(survey.SurveyEngineType === 'Internal')
                                                                {
                                                                    fancybox(<ComponentSurveyRunner surveyID={survey.SurveyID} isPreview={true} onComplete={answers => {
                                                                        console.log(answers);
                                                                    }} />)
                                                                }
                                                                else
                                                                {
                                                                    window.open(survey.SurveyLink, '_blank');
                                                                }

                                                            }}>{survey.SurveyEngineType === 'Internal' ? 'Preview' : 'Go To Survey Link'}</button>
                                                            {
                                                                survey.SurveyEngineType === 'Internal' &&
                                                                <button onClick={ e => {
                                                                    e.preventDefault();
    
                                                                    DownloadResponse(survey, props.auth.token);
                                                                    
    
                                                                }}>Download Response</button>
                                                            }
                                                            <button onClick={ e => {
                                                                e.preventDefault();

                                                                let ask = window.confirm('Are You Sure ?');

                                                                if(!ask)
                                                                {
                                                                    return;
                                                                }

                                                                const DeleteLoader = popinfo('preloader', 'Removing Survey', 'Please Wait');

                                                                api('/Survey', 'delete', {
                                                                    survey_id : survey.SurveyID
                                                                }, 'Bearer ' + props.auth.token)
                                                                    .then(response => {
                                                                        DeleteLoader.close();
                                                                        setSurveyLoadTick(Date.now());
                                                                    })
                                                                    .catch((error) => {
                                                                        popinfo('error', 'Removed Survey', error, {}, DeleteLoader);
                                                                    });
                                                            }}>Delete</button>
                                                            
                                                        </ThreeDots>
                                                    )
                                                }
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        )
                    }
                    {
                        activeSubPage === 'summary' && (
                            <div className="crowdbees-dashcards">
                                <div className="the-card --size-1">
                                    <div className="card-wrapper">
                                        <span className="card-title">Active Surveys <br/>using Internal Engine</span>
                                        <div>
                                            <div className="survey-card-total-survey--graph mb-lg">
                                                <span className="overall-bar">
                                                    <span className="filled-bar" style={{width: `${(surveys.filter(s => s.SurveyEngineType === 'Internal' && s.Quota > 0 && s.TotalResponse < s.Quota).length / 
                                                        Math.max(1, surveys.filter(s => s.SurveyEngineType === 'Internal' && s.Quota > 0).length)) * 100}%`}}></span>
                                                </span>
                                            </div>
                                            <ul className="survey-card-total-survey--stats">
                                                <li className="stats --active text-xs">
                                                    <span className="indicator"></span>
                                                    {surveys.filter(s => s.SurveyEngineType === 'Internal' && s.Quota > 0 && s.TotalResponse < s.Quota).length} Active Surveys
                                                </li>
                                                <li className="stats --closed text-xs">
                                                    <span className="indicator"></span>
                                                    {surveys.filter(s => s.SurveyEngineType === 'Internal' && s.Quota > 0 && s.TotalResponse >= s.Quota).length} Completed Surveys
                                                </li>
                                            </ul>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="the-card --size-2">
                                    <div className="card-wrapper">
                                        <span className="card-title">Total Response</span>
                                        <div className="survey-card-recap-participant">
                                            <ul className="surveys">
                                                {[...surveys]
                                                    .sort((a, b) => {
                                                        if (a.SurveyEngineType === 'Internal' && b.SurveyEngineType !== 'Internal') return -1;
                                                        if (a.SurveyEngineType !== 'Internal' && b.SurveyEngineType === 'Internal') return 1;
                                                        return b.TotalResponse - a.TotalResponse;
                                                    })
                                                    .map((survey, index) => (
                                                        <li key={index} className="survey text-sm">
                                                            <div className="survey-name">{survey.SurveyTitle}</div>
                                                            <div className="survey-participant-bar">
                                                                {survey.SurveyEngineType === 'Internal' && (
                                                                    <span className="overall-bar">
                                                                        <span className="filled-bar" style={{width: `${(survey.TotalResponse / Math.max(1, survey.Quota)) * 100}%`}}></span>
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <div className="survey-quota">
                                                                {survey.SurveyEngineType === 'Internal' ? (
                                                                    <>
                                                                        <span className="font-semibold">{survey.TotalResponse}</span> / {survey.Quota}
                                                                    </>
                                                                ) : (
                                                                    <span className="font-semibold">{survey.TotalView} View</span>
                                                                )}
                                                            </div>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
})

export default PageInitiativeInsideSurvey;
export {DownloadResponse}